import React, { useState,useEffect } from "react";
import ProfileImg from '../../Assets/images/profile-main.png';
import ProfileEditImg from '../../Assets/images/edit-profile.svg';
import { get,post } from "../../Services/Api";
import {Modal, notification } from "antd";
import AdminSidebar from '../../Components/AdminSidebar';
import Avatar1 from '../../Assets/images/avatar.png'



const Profile = () => {
    const [userDetails,setuserDetails] = useState([]);
    const [admin_id,setAdminId] = useState(null);
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [selectedUser, setSelectedUser] = useState({
      first_name: "",
      last_name: "",
      username: "",
      userpassword: "",
    });
     const [errors, setErrors] = useState({});

    useEffect(() => {
        const storedAdminId = localStorage.getItem("adminId"); 
        setAdminId(storedAdminId); 
      }, []);

    useEffect(() => {
        if (!admin_id) return;
        fetchUserProfile();
      }, [admin_id]);
    
      // Fetch templates from API
      const fetchUserProfile = async () => {
        try {
        //   const response = await get(`http://192.168.96.120:5000/apis/listprofile/${admin_id}`);
          const response = await get(`listprofile/${admin_id}`);
          if (response?.status === 200) {
            setuserDetails(response.data);
          } else {
            throw new Error("Invalid API response");
          }
        } catch (error) {
          console.error("Error fetching User:", error);
          notification.error({
            message: "Error Fetching User Details",
            description: "Unable to fetch user. Please try again later.",
          });
        }
      };

      const handleEditClick = () => {
        setErrors({})
        setSelectedUser({
          first_name: userDetails?.first_name || "",
          last_name: userDetails?.last_name || "",
          username: userDetails?.email || "",
          userpassword: userDetails?.password || "",
        });
        setIsModalVisible(true);
      };

      const validateEditFields = () => {
        const newErrors = {};
      
        if (!selectedUser.first_name.trim()) newErrors.first_name = "First Name is required.";
        if (!selectedUser.last_name.trim()) newErrors.last_name = "Last Name is required.";
      
        // Email validation
        if (!selectedUser.username.trim()) {
          newErrors.username = "Email is required.";
        } else if (!validateEmail(selectedUser.username)) {
          newErrors.username = "Please enter a valid email address.";
        }
      
        // Password validation (at least 8 characters)
        if (selectedUser.userpassword && selectedUser.userpassword.length < 8) {
          newErrors.userpassword = "Password must be at least 8 characters long.";
        }
      
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
      };

      const validateEmail = (email) => {
        // Regex for basic email validation
        // const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        const emailRegex = /^[a-zA-Z0-9](?!.*\.\.)[a-zA-Z0-9._%+-]*@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        return emailRegex.test(email);
      };

       // Handle modal submission
  const handleModalOk = async () => {
    if (!validateEditFields()) {
      return; // Stop submission if validation fails
    }
    // const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const emailRegex = /^[a-zA-Z0-9](?!.*\.\.)[a-zA-Z0-9._%+-]*@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

    if (!selectedUser.first_name || !selectedUser.last_name || !selectedUser.username || !selectedUser.userpassword) {
      notification.error({
        message: "Validation Error",
        description: "All fields are required. Please fill in the missing information.",
        placement: "topRight",
      });
      return;
    }

    if (!emailRegex.test(selectedUser.username)) {
      notification.error({
        message: "Validation Error",
        description: "Please enter a valid email address.",
        placement: "topRight",
      });
      return;
    }

    const payload = {
      username: selectedUser.username,
      userpassword: selectedUser.userpassword,
      first_name: selectedUser.first_name,
      last_name: selectedUser.last_name,
    };

    try {
      await post(`edituser/${admin_id}`, payload);


      notification.success({
        message: "User Updated",
        description: `${selectedUser.first_name} ${selectedUser.last_name} has been successfully updated.`,
        placement: "topRight",
      });
      fetchUserProfile()

      setIsModalVisible(false);
    } catch (error) {
      notification.error({
        message: "Error Updating User",
        description: "There was an error updating the user. Please try again later.",
        placement: "topRight",
      });
    }
  };

 
      


  return (
    <div className="row">
    <div className="d-flex align-items-center">
    <AdminSidebar />
    <div className="col-size-8">
    <div className="inside-filter">
      <div className="col-lg-12">
        <div className="d-flex align-items-center justify-content-between">
          <div className="mb-3">
            <h4>My profile</h4>
          </div>
        </div>
      </div>
      <div className="col-lg-12">
          <div className="card-inside h-auto">
            <div className="d-flex align-items-center justify-content-between">
            <div className="d-flex align-items-center">
                <div>
                    <img src={Avatar1} alt="" className="" style={{width: '120px'}} />
                </div>
                <div className="ms-4">
                    <h4 className="font-600">
                    {/* Jack Adams */}
                    {userDetails.first_name} {userDetails.last_name}
                    </h4>
                    {/* <p className="mb-0">
                    Los Angels, California, USA
                    </p> */}
                </div>
                </div>
                <div className="d-flex align-items-center justify-content-center" onClick={handleEditClick} style={{border: '1px solid #DDDDDD', width:'100px', padding: '5px 15px', borderRadius: '50px', cursor: 'pointer'}}>
                    <img src={ProfileEditImg} alt="" />
                    <p className="mb-0 ms-2">Edit</p>
                </div>
            </div>
          </div>
          <div className="card-inside mt-3 h-auto">
                <div className="d-flex align-items-center justify-content-between mb-4">
                <h4 className="font-600 ">
                Personal Information
                </h4>
                {/* <div className="d-flex align-items-center justify-content-center" style={{border: '1px solid #DDDDDD', width:'100px', padding: '5px 15px', borderRadius: '50px'}}>
                    <img src={ProfileEditImg} alt="" />
                    <p className="mb-0 ms-2">Edit</p>
                </div> */}
                </div>
               
                <div className="d-flex align-items-center flex-wrap mb-2">
                    <div className="profile-details">
                        <label htmlFor="">First Name</label>
                        <p>
                        {/* Jack */}
                        {userDetails?.first_name}
                        </p>
                    </div>
                    <div className="profile-details">
                    <label htmlFor="">Last Name</label>
                        <p>
                        {/* Adams */}
                        {userDetails?.last_name}
                        </p>
                    </div>
                </div>
                <div className="d-flex align-items-center flex-wrap">
                    <div className="profile-details">
                        <label htmlFor="">Email address</label>
                        <p>
                        {userDetails?.email}
                        </p>
                    </div>
                    {/* <div className="profile-details">
                    <label htmlFor="">Phone</label>
                        <p>
                        (213) 555-1234
                        </p>
                    </div> */}
                </div>
          </div>
          {/* <div className="card-inside mt-3 h-auto">
          <div className="d-flex align-items-center justify-content-between mb-4">
                <h4 className="font-600 ">
                Address
                </h4>
                <div className="d-flex align-items-center justify-content-center" style={{border: '1px solid #DDDDDD', width:'100px', padding: '5px 15px', borderRadius: '50px'}}>
                    <img src={ProfileEditImg} alt="" />
                    <p className="mb-0 ms-2">Edit</p>
                </div>
                </div>
                <div className="d-flex align-items-center flex-wrap mb-2">
                    <div className="profile-details">
                        <label htmlFor="">Country</label>
                        <p>
                        United states of America
                        </p>
                    </div>
                    <div className="profile-details">
                    <label htmlFor="">City</label>
                        <p>
                        California
                        </p>
                    </div>
                </div>
                <div className="d-flex align-items-center flex-wrap">
                    <div className="profile-details">
                        <label htmlFor="">Postal Code</label>
                        <p>
                        ERT 62574
                        </p>
                    </div>
                    <div className="profile-details">
                    <label htmlFor="">State</label>
                        <p>
                        USA
                        </p>
                    </div>
                </div>
          </div> */}
      </div>


      <Modal
        title="Edit User"
        visible={isModalVisible}
        onOk={handleModalOk}
        onCancel={() => setIsModalVisible(false)}
        okText="Save Changes"
        cancelText="Discard"
        okButtonProps={{
          style: {
            borderRadius: "20px",
            minWidth: "150px",
            padding: "1.2rem 0.75rem",
          },
        }}
        cancelButtonProps={{
          style: {
            borderRadius: "20px",
            minWidth: "150px",
            padding: "1.2rem 0.75rem",
          },
        }}
      >
        {selectedUser && (
          <div style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
            <div style={{ display: "flex", flexDirection: "column", marginTop: "16px" }}>
              <label>First Name</label>
              <input
                type="text"
                value={selectedUser.first_name}
                onChange={(e) => {
                  const value = e.target.value;
                  if (/^[A-Za-z\s]*$/.test(value) && value.length<=20) { 
                    setSelectedUser({ ...selectedUser, first_name: value });
                  }
                }}
                // className="form-control"
                className={`form-control ${errors.first_name ? 'is-invalid' : ''}`}
              />
              {errors.first_name && <div className="invalid-feedback">{errors.first_name}</div>}
            </div>
            <div style={{ display: "flex", flexDirection: "column" }}>
              <label>Last Name</label>
              <input
                type="text"
                value={selectedUser.last_name}
                onChange={(e) => {
                  const value = e.target.value;
                  if (/^[A-Za-z\s]*$/.test(value) && value.length<=20) { 
                    setSelectedUser({ ...selectedUser, last_name: value });
                  }
                }}
                // className="form-control"
                className={`form-control ${errors.last_name ? 'is-invalid' : ''}`}
              />
              {errors.last_name && <div className="invalid-feedback">{errors.last_name}</div>}
            </div>
            <div style={{ display: "flex", flexDirection: "column" }}>
              <label>Email</label>
              <input
                type="email"
                value={selectedUser.username}
                onChange={(e) => setSelectedUser({ ...selectedUser, username: e.target.value })}
                // className="form-control"
                className={`form-control ${errors.username ? 'is-invalid' : ''}`}
              />
              {errors.username && <div className="invalid-feedback">{errors.username}</div>}
            </div>
            <div style={{ display: "flex", flexDirection: "column", marginBottom: "15px" }}>
              <label>Password</label>
              <input
                type="text"
                value={selectedUser.userpassword}
                onChange={(e) => setSelectedUser({ ...selectedUser, userpassword: e.target.value })}
                // className="form-control"
                className={`form-control ${errors.userpassword ? 'is-invalid' : ''}`}
              />
              {errors.userpassword && <div className="invalid-feedback">{errors.userpassword}</div>}
            </div>
          </div>
        )}
      </Modal>
      </div>
    </div>
    </div>
    </div>

    
  );
};

export default Profile;
